import { registerLocaleData } from "@angular/common";
import localeEN from "@angular/common/locales/en";
import localeES from "@angular/common/locales/es";
import localePT from "@angular/common/locales/pt";
import { enableProdMode } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import config from "devextreme/core/config";
import { licenseKey } from "devextreme-license";
import { environment } from "environments/environments";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";

// Registra os dados de locale suportados no arranque, ANTES de qualquer componente/rota.
// Necessário para o DatePipe/FormatDatePipe funcionar também em rotas públicas/externas
// (ex.: SendDocuments), que não passam pela inicialização de locale feita após o login
// (LocaleService.registerCulture). Sem isso, o fallback "pt-BR" quebra com NG0701.
registerLocaleData(localePT);
registerLocaleData(localeES);
registerLocaleData(localeEN);

// Aplica a licença DevExtreme no arranque, ANTES do bootstrap e de qualquer componente
// DevExpress ser instanciado. Garante a licença também em telas anônimas/públicas
// (ex.: emissão de relatórios XtraReports em SendDocuments), que não passam pela
// inicialização pós-login. Complementa o config() de currency/formato feito após o login.
config({ licenseKey: licenseKey });

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
